export default __webpack_public_path__ + "static/media/ico-camera.ae3ce7ef.svg";